import { TooltipPlacement } from "designSystem/types/tooltip-types";
import React, { FunctionComponent, useCallback, useState } from "react";
import Tooltip from "../tooltip/Tooltip";
import TextField, { TextFieldProps } from "./TextField";

export interface OverflowTextFieldProps extends Omit<TextFieldProps, "variant"> {
	/** tooltip for textbox */
	tooltipPlacement?: TooltipPlacement;
}

const OverflowTextField: FunctionComponent<OverflowTextFieldProps> = (props) => {
	const [overflows, setOverflows] = useState(false);
	const { InputProps, tooltipPlacement, ...otherProps } = props;
	const value = props.inputProps["value"];

	const inputRef = useCallback((node: HTMLElement) => {
		if (node) {
			setOverflows(node.scrollWidth > node.clientWidth);
		}
	}, [value]);

	return (
		<Tooltip
			disableFocusListener
			disableHoverListener={!overflows}
			disableTouchListener
			placement={tooltipPlacement}
			title={value}
		>
			<TextField InputProps={{ ...InputProps, inputRef }} {...otherProps} />
		</Tooltip>
	);
};

export default OverflowTextField;